import { render, staticRenderFns } from "./AdminGroupLeader.vue?vue&type=template&id=3c77de51&scoped=true&"
import script from "./AdminGroupLeader.vue?vue&type=script&lang=js&"
export * from "./AdminGroupLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77de51",
  null
  
)

export default component.exports